import { render, staticRenderFns } from "./plc.vue?vue&type=template&id=363b6e07&scoped=true"
import script from "./plc.vue?vue&type=script&lang=js"
export * from "./plc.vue?vue&type=script&lang=js"
import style0 from "./plc.vue?vue&type=style&index=0&id=363b6e07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b6e07",
  null
  
)

export default component.exports